module.exports = "/images/witness-icon.svg?98612b2fd8c2e3169b7563fde9627be6";